import { render, staticRenderFns } from "./CamerasGallery.vue?vue&type=template&id=dd7038f4&scoped=true&"
import script from "./CamerasGallery.vue?vue&type=script&lang=js&"
export * from "./CamerasGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7038f4",
  null
  
)

export default component.exports